/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {BulkAddReferenceableSyncEntityRequest} from '@cash-web/protos/squareup/cash/clientsync/service.pb'
import {BulkAddReferenceableSyncEntityResponse} from '@cash-web/protos/squareup/cash/clientsync/service.pb'


export const bulkAddReferenceableSyncEntity = (request:BulkAddReferenceableSyncEntityRequest, options?: CashRequestOptions) => post<BulkAddReferenceableSyncEntityRequest, BulkAddReferenceableSyncEntityResponse>("/2.0/cash/bulk-add-referenceable-sync-entity", request, {...options, rejectOnError: true })